import { createModel } from "@rematch/core";

import type { RootModel } from '.';
import { PaginationFactory } from '../factory';
import { DeviceTypes } from '../types';

export interface DeviceStoreProps {
    pagination: PaginationFactory<DeviceTypes.Model>,
    loading: {
        fetchMany: boolean,
        delete: boolean,
        unassign: boolean,
    },
};

export const deviceInitialState = {
    pagination: {} as PaginationFactory<DeviceTypes.Model>,
    loading: {
        fetchMany: false,
        delete: false,
        unassign: false,
    },
};

export const device = createModel<RootModel>()({
    state: deviceInitialState,
    reducers: {
        boot: (store) => {
            store = deviceInitialState;
        },
        toggleLoading: (
            store, prop: keyof DeviceStoreProps['loading'], v: boolean) => {
                store.loading[prop] = v;
            },
        setPagination: 
            (store, pagination: PaginationFactory<DeviceTypes.Model>) => {
                store.pagination = pagination;
            },
        destroyDevice: 
            (store, id: string) => {
                store.pagination.items = store.pagination.items.filter(i => i.id !== id);
            },
    },
});
